/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_ActionsInputs */

const en_case_payment_actions = /** @type {(inputs: Case_Payment_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment actions`)
};

const pt_br2_case_payment_actions = /** @type {(inputs: Case_Payment_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações do pagamento`)
};

/**
* | output |
* | --- |
* | "Payment actions" |
*
* @param {Case_Payment_ActionsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_actions = /** @type {((inputs?: Case_Payment_ActionsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_ActionsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_actions(inputs)
	return pt_br2_case_payment_actions(inputs)
});